<template>
  <v-form
    class="w-100"
    ref="form"
    v-model="isValidForm"
    lazy-validation
    @submit.prevent="handleFormSubmit"
  >
    <v-row>
      <v-col cols="12" class="mb-9">
        <h6 class="text-h6 text-center">{{ $t("login.page-heading") }}</h6>
      </v-col>
      <v-col cols="12" class="mb-2">
        <v-text-field
          :label="$t('login.form.username')"
          type="text"
          :rules="rule.username"
          v-model.trim="form.username"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="mb-2">
        <v-text-field
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          :label="$t('login.form.password')"
          @click:append="showPassword = !showPassword"
          :rules="rule.password"
          v-model.trim="form.password"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          type="submit"
          color="primary"
          class="text-none body-2 font-weight-medium mb-2"
          depressed
          block
          large
          :loading="loading"
        >
          {{ $t("login.button.submit") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import authenticationMixins from "@/mixins/authenticationMixins";

export default {
  mixins: [authenticationMixins],
  data() {
    return {
      showPassword: false,
      isValidForm: true,
      loading: false,
      rule: {
        username: [(v) => !!v || this.$t("login.rule.username")],
        password: [(v) => !!v || this.$t("login.rule.password")],
      },
      form: {
        username: null,
        password: null,
      },
    };
  },
  methods: {
    async handleFormSubmit() {
      if (this.isValidForm && this.$refs.form.validate()) {
        try {
          this.loading = true;
          await this.globalLogin(this.form, () => {
            this.form.password = null;
            this.$refs.form.resetValidation();
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
